require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;



//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/core-js/library/fn/object/keys.js
// module id = 330
// module chunks = 0